if (!customElements.get('sticky-atc-bar')) {
	function checkBarVisibility() {
	  const stickyAtcBar = document.querySelector(".sticky-atc-bar");
	  const productVisible = document.querySelector(".product .product__info-wrapper");
	  let closedBar = false;
	  const closeBtn = document.querySelector(".sticky-close-button");
  
	  document.addEventListener("scroll", (e) => {
		let productVisibleHeight = productVisible.offsetHeight / 2;
		let scrolled = document.scrollingElement.scrollTop;
	
		if (scrolled > productVisibleHeight && !closedBar) {
		  stickyAtcBar.classList.add('atc-visible');
		} else {
		  stickyAtcBar.classList.remove('atc-visible');
		}
	  });
  
	  closeBtn.addEventListener('click', () => {
		stickyAtcBar.classList.remove('atc-visible');
		closedBar = true
	  })
  
	}
  
	document.addEventListener('DOMContentLoaded', checkBarVisibility);
	document.addEventListener('shopify:section:load', checkBarVisibility);
  
	const stickyAtcSelect = document.querySelector('sticky-atc-bar .select__select');
	let atcPrice = document.querySelector('sticky-atc-bar .price-item--regular');
	let atcImage = document.querySelector('sticky-atc-bar img');
	// Update the bar's price (sale price + struck-through original) and image from a variant <option>
	function applyStickyOption(selectedOption) {
		if (!selectedOption) return;
		const getNewPrice = selectedOption.getAttribute('data-price');
		const getOriginalPrice = selectedOption.getAttribute('data-original-price');
		const stickyBar = document.querySelector('sticky-atc-bar');
		if (getNewPrice) {
			stickyBar.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (el) {
				el.innerHTML = getNewPrice;
			});
		}
		if (getOriginalPrice) {
			stickyBar.querySelectorAll('.price__sale s.price-item--regular').forEach(function (el) {
				el.innerHTML = getOriginalPrice;
			});
		}
		const getNewImage = selectedOption.getAttribute('data-media');
		if (getNewImage != null && atcImage) {
			atcImage.src = getNewImage;
		}
	}

	if (stickyAtcSelect) {
	  stickyAtcSelect.onchange = function(){
		applyStickyOption(stickyAtcSelect.options[this.selectedIndex]);
	  };

	  // Keep the bar in sync when the variant is changed on the main product form (quantity/potency pills etc.)
	  const syncStickyWithMainVariant = function () {
		if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return false;
		subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
			const variant = event && event.data && event.data.variant;
			if (!variant) return;
			const option = Array.from(stickyAtcSelect.options).find(function (o) { return o.value == variant.id; });
			if (!option) return;
			stickyAtcSelect.value = option.value;
			applyStickyOption(option);
		});
		return true;
	  };
	  if (!syncStickyWithMainVariant()) {
		document.addEventListener('DOMContentLoaded', syncStickyWithMainVariant);
	  }
	}

	class StickyAtcBar extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.select = this.querySelector('.select');
			this.formBtn = this.querySelector('.button-add-card')

			this.onVariantChange();
		}
		onVariantChange = () => {
			if (!this.select) return;
			this.select.addEventListener('change', (e) => {
				this.updateMasterId(e);
				this.renderProductInfo();
			})
		};

		updateMasterId(e) {
			this.currentVariant = e.target.value;
		}

		renderProductInfo() {
			const requestedVariantId = this.currentVariant;
			fetch(
				`${this.dataset.url}?variant=${requestedVariantId}`
			)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const addButtonUpdated = html.querySelector('.main-product .product-form__submit');
					this.toggleAddButton(
						addButtonUpdated.hasAttribute('disabled'),
						window.variantStrings.soldOut
					);

					const priceHtml = html.querySelector('.product__info-wrapper .price');
					this.updatePrice(priceHtml);
				})
				.catch((error) => {
					console.error('Error:', error);
				})
		}
		toggleAddButton(disable = true, text, modifyClass = true) {
			const addButton = this.formBtn;
			if (!addButton) return;

			const addButtonText = addButton.querySelector('span');

			if (disable) {
				addButton.setAttribute('disabled', 'disabled');
				if (text) {
					if (addButtonText) addButtonText.textContent = text;
				}
			} else {
				addButton.removeAttribute('disabled');
				if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
			}

			if (!modifyClass) return;
		}

		updatePrice(price) {
			this.price = this.querySelector('.price');

			if (!this.price || !price) return;
			const duplicatePrice = price.cloneNode(true);
			this.price.replaceWith(duplicatePrice);
		}
	}

	customElements.define('sticky-atc-bar', StickyAtcBar);
  
}